import React from 'react';
import './CardJuridique.css';

const CardJuridique = (props) => {

    return (
        <div className={`card-juridique ${props.backgroundColor ?  "background-blue" : null}`} >
            <img src={props.icon} alt="pictos juridique" />
            {props.title}
            {/* <h3 className={`card-juridique-title ${props.backgroundColor ? "font-white" : null}`} >{props.title}</h3> */}
            {props.children}
        </div>
    )
}

export default CardJuridique;